export default __webpack_public_path__ + "56435da2448caaff95b05759954ec6ee.woff2";